(ns common.schema.entities.calculated.indirect-holding.core
  (:require [common.schema.entities.calculated.indirect-holding :as indirect-holding]))

;; Verbatim copy of common.schema.entity-types's existing
;; :entity.type/calculated-indirect-holding entry (entity_types.cljc around
;; line 1873-1884, using calculated-entity-delete-check-fn defined around
;; line 307 there, itself just delete-not-allowed!) - required here, not
;; there, to avoid a circular namespace dependency (entity_types.cljc
;; requires this registry). Keep in sync if the original ever changes.
(defn- read-permissions-check-fn
  [{:keys [account-current-permissions]}]
  (contains? (:account-modules account-current-permissions)
             :module/portfolio))

(defn- disable-permissions-check-fn
  [{:keys [tr]}]
  (tr :not-allowed))

(def entity-type-definition
  {:entity-type                  :entity.type/calculated-indirect-holding
   :schema                       indirect-holding/schema
   :name                         {:en "Indirect holding"}
   :plural                       {:en "Indirect holdings"}
   :icon                         :fa-briefcase
   :entity/calculated?           true
   :read-permissions-check-fn    read-permissions-check-fn
   :disable-permissions-check-fn disable-permissions-check-fn

   ;; Unlike every other entity ported to the new-grid engine this session,
   ;; :entity.type/calculated-indirect-holding has no Datomic entities at
   ;; all - a row is synthesized per :association.type/holding association
   ;; between a fof-asset (itself the target of a real
   ;; :entity.type/holding) and another asset. Registering it here is what
   ;; lets backend.domain.entities.calculated-indirect-holding.core supply
   ;; a genuinely custom :search/dedicated-query-fn in place of the default
   ;; :common/tenant + :entity/type Datomic query every other entity uses
   ;; (there is nothing for that default query to find). See that
   ;; namespace's docstring for the delta-indexing caveat this introduces.
   ;;
   ;; No :result/title-attr - there is no single natural display name for a
   ;; fund/holding pair, so kanban/gallery (which need one) are left out of
   ;; :available-view-modes below rather than picking an arbitrary one.
   ;; :list/default-columns lists just the two refs themselves (matching
   ;; investor's own :investor/legal-entity precedent for a deep-indexed
   ;; ref field) - every nested fund/holding-target field the legacy grid's
   ;; own dynamic column picker showed is still reachable via this
   ;; listing's column picker, just not defaulted.
   :search                       {:list/default-columns [:indirect-holding/fund
                                                         :indirect-holding/holding-target]
                                  :views {:grid {:po-default-field-paths [[:indirect-holding/fund]
                                                                          [:indirect-holding/holding-target]]
                                                 :mandatory-field-paths []}}}})
